
import { updateBill, deleteBill, registerBill } from './BusinessBillsService';
import { extractError } from '../../api/ErrorUtil';
import _ from "lodash";
import { evenRound } from 'util/NumberUtils';
import { formatDate, stringDateToUTC, stringUTCToLocal } from 'util/Date';

export const businessBillFormDataInitialState = {
  billType: "ACCOUNT",
  amountDue: '',
  dueDate: "",
  billDate: "",
  accountId: "",
  billId: "",
  account: {},
  lineItems: [],
  billsData: [],
  accountsData: [],
  accountTypes: [],
  billNumber: "",
  successmessage: [],
  infoMessage: '',
  loading: false,
  newBill: true,
  errors: {},
  redirectToEdit: false,
  recurringBill: false,
  billStatus: "NOT_PAID",
  actionType: "",
  keyword: "",
  fromBillDate: "",
  toBillDate: ""
}

const predicate = (item) => {
  let x = item[1];
  const x1 = x['lineItemAmount'];
  const x2 = x['lineItemDescription']
  const x3 = x['taxable'];

  const istrue =
    x1 !== '' && x1 !== 0 &&
    x2 !== '' &&
    x3 !== ''
  return istrue;
}
const filterEmptyEntries = (unfileredArray) => {

  let filtered = [];
  filtered = Object.fromEntries(Object.entries(unfileredArray).filter(predicate));
  return Object.values(filtered);
}


const getBusinessBillObjectFromForm = (data) => {

  let businessBillObj = {
    businessBill: {
      billType: data.billType,
      amountDue: data.amountDue,
      dueDate: stringDateToUTC(data.dueDate),
      billDate: stringDateToUTC(data.billDate),
      accountId: data.accountId,
      billId: data.billId,
      lineItems: filterEmptyEntries(data.lineItems),
      billNumber: data.billNumber ? data.billNumber : null,
      recurringBill: data.recurringBill,
    }
  }
  return (
    businessBillObj.businessBill)
}


export const AsyncBusinessBillDataHandlers = {
  FORM_SUBMIT: ({ dispatch, getState, signal }) => async (action) => {
    let { formData } = action.payload;
    let redirectToEdit = false;
    dispatch({ type: 'FORM_SUBMITTING' });
    let businessBillOpResponse = null;

    try {
      let message = "";
      let actionType = formData.type;
      if (formData.type === 'Add') {
        businessBillOpResponse = await registerBill(getBusinessBillObjectFromForm(formData));
        redirectToEdit = true;
        message = "Bill added successfully";
      } else if (formData.type === 'Delete') {
        businessBillOpResponse = await deleteBill(formData.billId);
        message = "Bill deleted successfully";
      } else {
        businessBillOpResponse = await updateBill(formData.billId, getBusinessBillObjectFromForm(formData));
        message = "Bill updated successfully";
      }
      dispatch({ type: 'FORM_SUBMIT_SUCCESS', payload: { response: businessBillOpResponse, redirectToEdit: redirectToEdit, message: message, actionType: actionType } });
    } catch (error) {
      console.log(error);
      let errorMsg = extractError(error);
      console.log(errorMsg);
      dispatch({ type: 'FORM_SUBMIT_FAIL', payload: { error: errorMsg } });
    }
  }
};

export const BusinessBillFormDataReducer = (state, action) => {

  if (action.type === 'POPULATE_FORM') {

    let billData = action.payload;

    let accFilterArray = state.accountsData?.filter(acc => acc.account.id === billData.accountId);
    let account = null;
    let accType = null;
    if (!_.isEmpty(accFilterArray)) {
      account = accFilterArray[0].account;
      let accTypesArray = state.accountTypes.filter(accType => accType.id === accFilterArray[0]?.account.accountTypeId);
      if (!_.isEmpty(accTypesArray)) {
        accType = accTypesArray[0];
      }
    }

    let businessAccountBill = {
      billType: billData.billType,
      amountDue: billData.amountDue,
      dueDate: formatDate(stringUTCToLocal(billData.dueDate)),
      billDate: formatDate(stringUTCToLocal(billData.billDate)),
      accountId: billData.accountId,
      billId: billData.billId,
      lineItems: billData.lineItems,
      billNumber: billData.billNumber,
      accountsData: state.accountsData,
      accountTypes: state.accountTypes,
      recurringBill: billData.recurringBill,
      billStatus: billData.billStatus,
      account: account,
      accountType: accType
    }

    return { ...businessAccountBill, newBill: false };

  }


  if (action.type === 'FIELD_CLEAR') {
    return businessBillFormDataInitialState;
  }

  if (action.type === 'FORM_SUBMITTING') {
    return {
      ...state,
      readOnly: true,
      status: "Submitting Form...",
      infoMessage: '',
      errors: {},
      loading: true
    }
  }

  if (action.type === 'FORM_SUBMIT_SUCCESS') {
    let { response, redirectToEdit, message, actionType } = action.payload;
    let newState = {};
    if (actionType === 'Delete') {
      newState = {
        ...state,
        billType: "ACCOUNT",
        amountDue: '',
        dueDate: "",
        billDate: "",
        accountId: "",
        success: true,
        readOnly: redirectToEdit,
        successmessage: message,
        infoMessage: message,
        errors: {},
        loading: false,
        redirectToEdit: redirectToEdit,
        actionType: actionType
      }
    } else {
      newState = {
        ...state,
        billId: response.id,
        success: true,
        readOnly: redirectToEdit,
        successmessage: message,
        infoMessage: message,
        errors: {},
        loading: false,
        redirectToEdit: redirectToEdit,
        actionType: actionType
      };
    }

    return newState;
  }

  if (action.type === 'FORM_SUBMIT_FAIL') {
    let { error } = action.payload;
    let newState = {
      ...state,
      readOnly: false,
      errors: error,
      loading: false
    };
    return newState;
  }

  if (action.type === 'UPDATE_LINE_ITEM') {
    const { key, targetCell } = action.payload;
    let bliClone = _.cloneDeep(state.lineItems);
    if ((targetCell.name).substring(0, 6) === 'amount') {
      Object.entries(bliClone)[key][1]['lineItemAmount'] = targetCell.value;
    } else if ((targetCell.name).substring(0, 11) === 'description') {
      Object.entries(bliClone)[key][1]['lineItemDescription'] = targetCell.value;
    } else if ((targetCell.name).substring(0, 7) === 'taxable') {
      Object.entries(bliClone)[key][1]['taxable'] = targetCell.checked;
    } else if ((targetCell.name).substring(0, 8) === 'quantity') {
      Object.entries(bliClone)[key][1]['quantity'] = targetCell.value;
    }

    let newState = {
      ...state,
      lineItems: bliClone
    };
    return newState;
  }

  
  if (action.type === 'FIELD_EDIT_ACCDATA') {
    const { name, value, infoMessage, errors } = action.payload;
    let accountsData = value.accounts;
    let accountTypes = value.accountTypes
    let newState = {
      ...state,
      accountsData: accountsData,
      accountTypes: accountTypes,
      infoMessage: infoMessage,
      errors: errors
    };
    return newState;
  }

  if (action.type === 'FIELD_EDIT_ACCOUNT') {
    const { name, value, infoMessage, errors } = action.payload;

    let account = value;
    let accType = null;
    let accTypesArray = state.accountTypes.filter(at => at.id === account.accountTypeId);
    if (!_.isEmpty(accTypesArray)) {
      accType = accTypesArray[0];
    }

    let newState = {
      ...state,
      account: account,
      accountType: accType,
      infoMessage: infoMessage,
      errors: errors
    };
    return newState;
  }

  if (action.type === 'FIELD_EDIT') {
    const { name, value, infoMessage, errors } = action.payload;
    let newState = {
      ...state,
      [name]: value,
      infoMessage: infoMessage,
      errors: errors
    };
    return newState;
  }

  if (action.type === 'FIELD_CLEAR_FILTERS') {
    const { name, value, infoMessage, errors } = action.payload;
    let newState = {
      ...state,
      [name]: value,
      infoMessage: infoMessage,
      errors: errors,
      keyword: "",
      fromBillDate: "",
      toBillDate: "",
    };
    return newState;
  }

  if (action.type === 'CALCULATE_AMOUNT_DUE') {
    const { salesTaxRate } = action.payload;
    let amountDue = 0.00;

    for (let li of state.lineItems) {
      let salesTax = 0.00;
      if (li.taxable) {
        salesTax = (parseFloat(li.lineItemAmount) * parseFloat(li.quantity)) * parseFloat(salesTaxRate);
      }
      amountDue = parseFloat(amountDue) + (parseFloat(li.lineItemAmount) * parseFloat(li.quantity)) + parseFloat(salesTax);
    }

    let newState = {
      ...state,
      amountDue: evenRound(amountDue * 100)

    };
    return newState;
  }

  if (action.type === 'IMPORT_LINE_ITEMS') {
    const { lineItems, salesTaxRate } = action.payload;
    let amountDue = 0.00;

    for (let li of lineItems) {
      let salesTax = 0.00;
      if (li.taxable) {
        salesTax = (parseFloat(li.lineItemAmount) * parseFloat(li.quantity)) * parseFloat(salesTaxRate);
      }
      amountDue = parseFloat(amountDue) + (parseFloat(li.lineItemAmount) * parseFloat(li.quantity)) + parseFloat(salesTax);
    }
    let newState = {
      ...state,
      lineItems: lineItems,
      amountDue: evenRound(amountDue * 100)
    };
    return newState;
  }

  if (action.type === 'REMOVE_LINE_ITEM') {
    const { index } = action.payload;
    let bliClone = _.cloneDeep(state.lineItems);
    if (index === 0) {
      bliClone.shift();
    } else {
      bliClone.splice(index, index);
    }
    return {
      ...state,
      lineItems: bliClone
    };

  }

  if (action.type === 'ERROR') {
    const { errors } = action.payload;
    return {
      ...state,
      errors: errors,

    }
  }

  if (action.type === 'CLEAR_INFO_AND_ERROR') {
    return {
      ...state,
      infoMessage: "",
      errors: {}
    }

  }


  //the following is for form edit and hence there should be a payload.
  //otherwise just return state

  if (!action.payload) {
    return state;
  }
}